import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authenticatedFetch } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import styles from './AuthCallback.module.css';

const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState(null);
    const [status, setStatus] = useState('Initializing...');
    const { handleAuthSuccess } = useAuth();
    const [processed, setProcessed] = useState(false);

    useEffect(() => {
        const handleCallback = async () => {
            if (processed) return;
            setProcessed(true);

            try {
                const searchParams = new URLSearchParams(location.search);
                const code = searchParams.get('code');
                const receivedState = searchParams.get('state');

                const storedState = localStorage.getItem('googleOAuthState');
                const redirectUri = localStorage.getItem('googleRedirectUri');

                if (!code || !receivedState || !storedState || !redirectUri) {
                    throw new Error('Missing required authentication parameters');
                }

                if (receivedState !== storedState) {
                    throw new Error('Invalid state parameter');
                }

                setStatus('Processing authentication...');

                const response = await authenticatedFetch('/api/auth/google/callback', {
                    method: 'POST',
                    body: {
                        code,
                        state: receivedState,
                        redirect_uri: redirectUri
                    }
                });

                if (!response || !response.token || !response.user) {
                    throw new Error('Invalid response from server');
                }

                handleAuthSuccess(response.token, response.user);

                localStorage.removeItem('googleOAuthState');
                localStorage.removeItem('googleRedirectUri');

                navigate('/dashboard', { replace: true });

            } catch (error) {
                console.error('Authentication error:', error);
                setError(error.message);
                setStatus('Error occurred');

                localStorage.removeItem('googleOAuthState');
                localStorage.removeItem('googleRedirectUri');
            }
        };

        if (location.search.includes('code=') && !processed) {
            handleCallback();
        }
    }, [location, navigate, handleAuthSuccess, processed]);

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className={styles.card}>
                        <div className={styles.errorContent}>
                            <h2 className={styles.title}>Authentication Error</h2>
                            <p className={styles.errorMessage}>{error}</p>
                            <p className={styles.statusText}>Status: {status}</p>
                            <button
                                onClick={() => navigate('/login')}
                                className={styles.button}
                            >
                                Return to Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.card}>
                    <h2 className={styles.title}>Completing sign in...</h2>
                    <p className={styles.statusText}>{status}</p>
                </div>
            </div>
        </div>
    );
};

export default AuthCallback;